import axios from 'axios';
import { settings } from '@/api/config';
import { FlyerResponse } from '@/pages/Tasks/adapters/sponsors/types/flyer';
import { SponsorsService } from '@/pages/Tasks/services/SponsorsService';
import { getInitData } from '@/utils/getInitData';

export const getFlyerTasks = async (): Promise<FlyerResponse> => {
  if (!getInitData()) {
    throw new Error('initData отсутствует');
  }
  const encodedInitData = encodeURIComponent(getInitData());
  const url = `${settings.url}api/tasks-external/flyer/get?initData=${encodedInitData}`;
  console.log('🚀 Flyer API request URL:', url);

  try {
    const response = await axios.get(url);
    console.log('🚀 Flyer API response:', response);
    console.log('📦 Flyer API response data:', response.data);
    return response.data;
  } catch (error) {
    console.error('❌ Flyer API error:', error);
    throw error;
  }
};

export const getTraffyTasks = async (): Promise<FlyerResponse> => {
  if (!getInitData()) {
    throw new Error('initData отсутствует');
  }
  const encodedInitData = encodeURIComponent(getInitData());
  const url = `${settings.url}api/tasks-external/traffy/get?initData=${encodedInitData}`;
  console.log('🚀  Traffy request URL:', url);

  try {
    const response = await axios.get(url);
    console.log('🚀  Traffy response:', response);
    console.log('📦 Traffy response data:', response.data);
    return response.data;
  } catch (error) {
    console.error('❌ Traffy API error:', error);
    throw error;
  }
};

export const getTgrassTasks = async (): Promise<FlyerResponse> => {
  if (!getInitData()) {
    throw new Error('initData отсутствует');
  }
  const encodedInitData = encodeURIComponent(getInitData());
  const url = `${settings.url}api/tasks-external/tgrass/get?initData=${encodedInitData}`;
  console.log('🚀  Tgrass request URL:', url);

  try {
    const response = await axios.get(url);
    console.log('🚀  Tgrass response:', response);
    console.log('📦 Tgrass response data:', response.data);
    return response.data;
  } catch (error) {
    console.error('❌ Tgrass API error:', error);
    throw error;
  }
};

export const getSubgramTasks = async (): Promise<FlyerResponse> => {
  if (!getInitData()) {
    throw new Error('initData отсутствует');
  }
  const encodedInitData = encodeURIComponent(getInitData());
  const url = `${settings.url}api/tasks-external/subgram/get?initData=${encodedInitData}`;
  console.log('🚀  Tgrass request URL:', url);

  try {
    const response = await axios.get(url);
    console.log('🚀  Subgram response:', response);
    console.log('📦 Subgram response data:', response.data);
    return response.data;
  } catch (error) {
    console.error('❌ Subgram API error:', error);
    throw error;
  }
};

export const checkFlyerTask = async (taskId: string): Promise<void> => {
  try {
    if (!getInitData()) {
      throw new Error('initData отсутствует');
    }
    const encodedInitData = encodeURIComponent(getInitData());
    const response = await axios.post(
      `${settings.url}api/tasks/flyer/check/${taskId}?initData=${encodedInitData}`,
    );
    console.log('🔍 Flyer task checked:', response);
    console.log('📦 Response data:', response.data);

    if (response.data.status === 'claim') {
      console.log('🔄 Updating status to DONE');
      SponsorsService.updateFlyerTaskStatus(taskId, 'DONE');
      return response.data;
    } else if (response.data.status === 'waiting') {
      console.log('🔄 Updating status to IN_PROGRESS');
      console.log('📞 Calling updateFlyerTaskStatus with:', {
        taskId,
        status: 'IN_PROGRESS',
      });
      SponsorsService.updateFlyerTaskStatus(taskId, 'IN_PROGRESS');
      console.log('✅ updateFlyerTaskStatus called');
      return response.data;
    } else if (response.data.status === 'not_started') {
      console.log('🔄 Updating status to NOT_STARTED');
      SponsorsService.updateFlyerTaskStatus(taskId, 'NOT_STARTED');
      return response.data;
    }
    return response.data;
  } catch (error) {
    console.error('❌ checkFlyerTask error:', error);
    SponsorsService.updateFlyerTaskStatus(taskId, 'NOT_STARTED');
    throw error;
  }
};

export const claimFlyerTask = async (taskId: string): Promise<void> => {
  if (!getInitData()) {
    throw new Error('initData отсутствует');
  }

  const encodedInitData = encodeURIComponent(getInitData());
  const response = await axios.post(
    `${settings.url}api/tasks/flyer/claim/${taskId}?initData=${encodedInitData}`,
  );
  console.log('🚀 Flyer task claimed:', response);
  return response.data;
};
